import React from 'react';
import CloseIcon from '@material-ui/icons/Close';
import { TYPE_BRIK } from 'utils';
import { Button } from "@material-ui/core";
import { arrowRight } from "assets/icons/importIcon";
import { iconGroups, iconSubscribers } from 'assets/icons/importIcon';
import useStyles from './styles';
import AppHelper from 'helpers/AppHelper';

const ChooseBrikType = (props: any) => {
  const classes = useStyles();
  const { nextStep, backStep, typeBrik, handleTypeBrik, isEdit, typeName, isTypeBrik, typeBrikGroup, handleCloseModal, isDuplicate, item } = props;

  const onHandleCloseModal = () => {
    if (handleCloseModal) {
      handleCloseModal();
    } else {
      AppHelper.hideGlobalModal();
    }

  };

  const renderTypeNameBrik = () => {

    if (item) {
      switch (item?.type_name) {
        case 0:
          return 'lesson plan';
        case 1:
          return 'program';
        case 2:
          return 'challenge';
        case 5:
          return 'life_and_leadership_coaching'
      }
    }
    switch (typeName) {
      case 0:
        return 'lesson plan';
      case 1:
        return 'program';
      case 2:
        return 'challenge';
      case 5:
        return 'life_and_leadership_coaching'
    }
  }

  const onClickTypeBrik = () => {
    if (typeBrikGroup) return
    handleTypeBrik(TYPE_BRIK.SUBSCRIBERS);
  }

  return (
    <>
      <div className={classes.bodyModalList}>
        <div className={classes.iconCloseIcon} onClick={onHandleCloseModal} data-cy="cypress-lesson-type-closed-button-modal">
          <CloseIcon />
        </div>
        <div className={classes.contentTitle} data-cy="cypress-lesson-type-modal-header">Who is this {renderTypeNameBrik()} for?</div>
        <div className={classes.listType}>
          <div
            className={classes.itemType}
            onClick={onClickTypeBrik}
            style={{ border: typeBrik === TYPE_BRIK.SUBSCRIBERS ? '1px solid #0C85F4' : '' }}
          >
            <img src={iconSubscribers} className={classes.icon} alt='' />
            <p className={classes.typeTitle} data-cy='cypress-lesson-public-type'>Public</p>
            <p className={classes.typeDes}>
              Anyone who creates an account can see this.
            </p>
            <p className={classes.typeDes}>
              This can be part of the subscription or additional cost as a separate item.
            </p>
          </div>

          <div
            className={classes.itemType2}
            onClick={() => handleTypeBrik(TYPE_BRIK.GROUPS)}
            style={{ border: typeBrik === TYPE_BRIK.GROUPS ? '1px solid #0C85F4' : '' }}
          >
            <img src={iconGroups} className={classes.icon} alt='' />
            <p className={classes.typeTitle} data-cy='cypress-lesson-private-type'>Private</p>
            <p className={classes.typeDes} style={{ marginBottom: 30 }}>
              Only people you invite can access this.
            </p>
            <p className={classes.typeDes}>
              You can set a 1-time payment or a recurring payment.
            </p>
          </div>
        </div>
      </div>
      <div className={classes.footerModal}>
        {
          !isDuplicate ?
            <div className={classes.buttonBack}>
              <Button variant="contained" onClick={(e: any) => backStep(e, props?.typeName)} disabled={isEdit} data-cy="cypress-lesson-plan-back-button">
                Back
              </Button>
            </div> : null
        }
        {
          !isDuplicate ?
            <div className={classes.btnAddRecipeBody}>
              <Button variant="contained" onClick={(e: any) => nextStep(e, props?.typeName)} disabled={isTypeBrik} data-cy="cypress-lesson-plan-next-button">
                <span>Next</span>
                <img src={arrowRight} alt="" />
              </Button>
            </div> : null
        }
      </div>
    </>
  );
};
export default ChooseBrikType;
